import { ConfigProvider } from 'antd';
import ruRU from 'antd/locale/ru_RU';
import React, { useState } from 'react';
import CabinetInformerTab from '../components/marketing/CabinetInformerTab';
import CabinetTelegramBroadcastsTab from '../components/marketing/CabinetTelegramBroadcastsTab';
import CabinetTelegramNotificationsTab from '../components/marketing/CabinetTelegramNotificationsTab';
import useCabinetMarketingSettings from '../hooks/useCabinetMarketingSettings';
import '../styles/marketing.css';
import '../styles/settings.css';

const MARKETING_TABS = [
  { key: 'informer', label: 'Информер' },
  { key: 'broadcasts', label: 'Рассылки в Telegram' },
  { key: 'notifications', label: 'Уведомления в Telegram' },
];

const Marketing = () => {
  const [activeTab, setActiveTab] = useState('informer');
  const marketing = useCabinetMarketingSettings();

  const handleTabKeyDown = (event, tabKey) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    setActiveTab(tabKey);
  };

  return (
    <ConfigProvider locale={ruRU}>
      <div className="marketing-page">
        <div className="sett-header">
          <h1 className="sett-header__title">Маркетинг</h1>
          <div className="sett-header__tabs" aria-label="Разделы маркетинга">
            {MARKETING_TABS.map((tab) => (
              <button
                key={tab.key}
                type="button"
                className={`sett-chip${activeTab === tab.key ? ' sett-chip--active' : ' sett-chip--outline'}`}
                onClick={() => setActiveTab(tab.key)}
                onKeyDown={(e) => handleTabKeyDown(e, tab.key)}
                aria-label={tab.label}
                aria-current={activeTab === tab.key ? 'page' : undefined}
              >
                <span className="sett-chip__label">{tab.label}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="marketing-page__content sett-tab-content">
          {activeTab === 'informer' && <CabinetInformerTab {...marketing} />}
          {activeTab === 'broadcasts' && <CabinetTelegramBroadcastsTab {...marketing} />}
          {activeTab === 'notifications' && <CabinetTelegramNotificationsTab {...marketing} />}
        </div>
      </div>
    </ConfigProvider>
  );
};

export default Marketing;
